// Recovered compiled webpack factory 31739. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { B: () => l });
  var n = i(48895),
    s = i(37822),
    r = i(9150),
    o = i(23919);
  let a = { ...s.ai, transform: (t) => Math.round((0, n.q)(0, 255, t)) },
    l = {
      test: (0, o.$)("rgb", "red"),
      parse: (0, o.q)("red", "green", "blue"),
      transform: ({ red: t, green: e, blue: i, alpha: n = 1 }) =>
        "rgba(" +
        a.transform(t) +
        ", " +
        a.transform(e) +
        ", " +
        a.transform(i) +
        ", " +
        (0, r.a)(s.X4.transform(n)) +
        ")",
    };
}
